import request from '@/utils/request'

let StoreApi = {

  /*添加门店*/
  addShop(data) {
    return request._post('/shop/store.store/add', data);
  },

  /*门店详情*/
  shopDetail(data) {
    return request._get('/shop/store.store/edit', data);
  },

  /*门店编辑*/
  editShop(data) {
    return request._post('/shop/store.store/edit', data);
  },

  /*删除门店*/
  deleteShop(data) {
    return request._post('/shop/store.store/delete', data);
  },

  /*门店列表*/
  shoplist(data) {
    return request._post('/shop/store.store/index', data);
  },

  /*门店选择列表*/
  storeLists(data) {
    return request._post('/shop/data.store/lists', data);
  },

  /*店员列表*/
  clerklist(data) {
    return request._post('/shop/store.clerk/index', data);
  },
  /*店员添加*/
  addClerk(data) {
    return request._post('/shop/store.clerk/add', data);
  },
  /*店员详情*/
  clerkDetail(data) {
    return request._get('/shop/store.clerk/edit', data);
  },
  /*店员编辑*/
  editClerk(data) {
    return request._post('/shop/store.clerk/edit', data);
  },
  /*删除店员*/
  deleteClerk(data) {
    return request._post('/shop/store.clerk/delete', data);
  },
    /*弹出层查询*/
  search(data) {
    return request._post('/shop/store.clerk/search', data);
  },
  /*核销订单列表*/
  orderList(data) {
    return request._post('/shop/store.order/index', data);
  },
 /*获取设置*/
 getSetting(data) {
  return request._get('/shop/store.store/setting', data);
},
/*保存设置*/
saveSetting(data) {
  return request._post('/shop/store.store/setting', data);
},

}

export default StoreApi;



// WEBPACK FOOTER //
// ./src/api/store.js